// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.admin.general.location.PracticeLocationTaxRequest */
/* istanbul ignore next */
@GandalfModel
export class PracticeLocationTaxRequest extends GandalfModelBase {

	@GandalfArray(Number)
	childTaxIds!: number[] | null;

	@GandalfValidator({ sizeString: { message: 'Description cannot be longer than 100 characters', minLength: 0, maxLength: 100 } })
	@GandalfProperty({ designType: String })
	description!: string | null;

	@GandalfValidator({ notNull: { message: 'Name is required' } })
	@GandalfValidator({ sizeString: { message: 'Name must be between 1 and 50 characters', minLength: 1, maxLength: 50 } })
	@GandalfProperty({ designType: String, isRequired: true })
	name!: string;

	@GandalfValidator({ notNull: { message: 'Rate is required' } })
	@GandalfValidator({ max: { max: 100, message: 'Tax Rate may not be more than 100%.' } })
	@GandalfProperty({ designType: Number, isRequired: true })
	rate!: number;

	@GandalfProperty({ designType: Number })
	taxId!: number | null;

	@GandalfProperty({ designType: Number })
	version!: number | null;

}
